var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useCallback, useState } from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
const StyledAccordion = styled(Accordion, {
    shouldForwardProp: (prop) => !['isDraggingOver'].includes(prop)
}) `
    background-color: ${({ isDraggingOver, theme }) => (isDraggingOver ? theme.palette.primary.background : 'inherit')};
    border-radius: 6px;
    position: relative;

    &.Mui-expanded {
        margin: 0;
    }

    &:before {
        display: none;
    }

    & .MuiAccordionSummary-expandIconWrapper {
        margin-right: 12px;
    }

    & .MuiAccordionSummary-root {
        // displays the expand arrow at the start
        flex-flow: row-reverse;

        &.Mui-expanded {
            min-height: 48px;
            margin: 0;
        }
    }

    & .MuiCollapse-hidden * {
        // fixes a bug with drag/drop where this still occupies space and leaks into the other accordions
        height: 0;
        margin: 0;
        padding: 0;
    }

    & .MuiAccordionDetails-root {
        padding: 0;
    }

    & .MuiAccordionSummary-content {
        align-items: center;
        margin: 0;
    }
`;
const SectionTitle = styled(Typography) `
    font-weight: 700;
    font-size: 16px;
`;
const SectionActions = styled(Box, {
    shouldForwardProp: (prop) => !['displayActions'].includes(prop)
}) `
    margin-left: auto;

    ${(props) => props.displayActions === 'active' &&
    `       
            opacity: 0;
            .Mui-expanded &, ${StyledAccordion}:hover &, ${StyledAccordion}:focus-within & {
                opacity: 1;
            }
        `}

    & .MuiButton-root:not(:last-child) {
        margin-right: 6px;
    }
`;
export const OrganizerSection = forwardRef((props, ref) => {
    const { title, id, expandIcon, accordionSummaryProps, accordionDetailsProps, actions, expanded: defaultExpanded = false, displayActions = 'active', children, dropPlaceholder, isDraggingOver = false } = props, other = __rest(props, ["title", "id", "expandIcon", "accordionSummaryProps", "accordionDetailsProps", "actions", "expanded", "displayActions", "children", "dropPlaceholder", "isDraggingOver"]);
    const [expanded, setExpanded] = useState(defaultExpanded);
    const onClick = useCallback((event) => {
        // workaround for the action buttons being inside the mui accordion tree
        if (event.target.tagName === 'BUTTON') {
            return;
        }
        setExpanded((current) => !current);
    }, []);
    return (_jsxs(StyledAccordion, Object.assign({ expanded: expanded, elevation: 0, isDraggingOver: isDraggingOver, ref: ref }, other, { children: [_jsxs(AccordionSummary, { "aria-controls": `${id}-content`, id: `${id}-header`, expandIcon: expandIcon !== null && expandIcon !== void 0 ? expandIcon : _jsx(ExpandMoreIcon, {}), onClick: onClick, children: [_jsx(SectionTitle, { children: title }), _jsx(SectionActions, { displayActions: displayActions, children: actions })] }), _jsxs(AccordionDetails, { id: `${id}-content`, children: [children, dropPlaceholder] })] })));
});
